import { use } from '../utils';

var _use = use('badge-group'),
    sfc = _use[0],
    bem = _use[1];

export default sfc({
  props: {
    activeKey: {
      type: [Number, String],
      "default": 0
    }
  },
  provide: function provide() {
    return {
      vanBadgeGroup: this
    };
  },
  data: function data() {
    return {
      badges: []
    };
  },
  render: function render(h) {
    return h("div", {
      "class": [bem(), 'van-hairline--top-bottom']
    }, [this.slots()]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.17@vant/es/badge-group/index.js
// module id = null
// module chunks = 